require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-marketing-automation-specialist.json") })
        }
      }, "path---authors-marketing-automation-specialist");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-marketing-automation-specialist!./.cache/json/authors-marketing-automation-specialist.json
// module id = 1314
// module chunks = 231608221292675